import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class MenuService{
    public menuStatus;

    public setMenuStatus(menuStatus){
        this.menuStatus = menuStatus;
    }
}
